import { render, staticRenderFns } from "./I_1-0-0__IR-Edit.vue?vue&type=template&id=3abee46c&"
import script from "./I_1-0-0__IR-Edit.vue?vue&type=script&lang=js&"
export * from "./I_1-0-0__IR-Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
